import React from 'react';
import { Link } from 'react-router-dom';
import '../style.css';
import Countdown from 'react-countdown';


function Footer({ currLang }) {

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>{currLang === "IS" ? "Sjáumst eftir " : "See you in "}
          <Countdown
            date={new Date("2026-07-18T00:00:00Z")}
            renderer={({ days, hours, minutes, seconds }) => (
              <span>
                {days} {currLang === "IS" ? "daga," : "days,"} {hours} {currLang === "IS" ? "klukkustundir," : "hours,"} {minutes} {currLang === "IS" ? "mínútur, og" : "minutes, og"} {seconds} {currLang === "IS" ? "sekúndur" : "seconds"}
              </span>
            )}
          />

        </p>
        <p>{currLang === "IS" ? "Magnea og Ásbjörn" : "Magnea and Ásbjörn"}</p>
      </div>
    </footer>
  );
}

export default Footer;